<script setup lang="ts">
import { Icon } from "@/components/Ui";

const { t } = useI18n();
</script>
<template>
  <div :class="$style.root">
    <div :class="$style.wrapper">
      <div :class="[$style.title, $style[`title-${$i18n.locale}`]]">
        {{ t("block.extCardsAtHand.title") }}
      </div>
      <div :class="$style.image">
        <Icon
          name="pst-black"
          path="cards"
        />
      </div>
      <div
        v-if="$slots.action"
        :class="$style.action"
      >
        <slot name="action" />
      </div>
    </div>
  </div>
</template>

<style lang="scss" module>
.root {
  @apply rounded-[40px] relative flex flex-col md:flex-row md:items-center lg:items-start lg:flex-col w-full overflow-hidden;
  @apply px-[30px] pt-10 pb-10 md:pt-10 md:pb-10 lg:px-[30px] lg:py-10;
  @apply min-h-[500px] xxs:min-h-[530px] md:min-h-[268px] lg:min-h-[530px];
  @apply text-white;
  background: linear-gradient(154.6deg, #f7d15f 0%, #ff7d00 100%);
}

.wrapper {
  @apply w-full h-full flex flex-col gap-5 justify-between md:w-1/2 md:ml-auto md:pl-8 md:justify-center lg:justify-between lg:pl-0 lg:ml-0 lg:w-full;
}

.image {
  @apply w-[394px];
  @screen md {
    @apply w-[352px] absolute left-0 -translate-x-3;
  }

  @screen lg {
    @apply w-[394px] translate-x-0 relative;
  }
  & svg {
    @apply w-full;
  }
}

.title {
  @apply font-extrabold leading-none mb-5 z-10;
  @apply text-[32px] xxs:text-[36px];
  &-en,
&-id,
&-da,
&-et,
&-hu,
&-lt,
&-nb,
&-ro,
&-sl,
&-cs,
&-el,
&-fi,
&-lv,
&-nl,
&-sk,
&-sv,
&-he,
  &-be,
  &-bg,
  &-it,
  &-ua,
  &-zh,
  &-de,
  &-bg,
  &-ru,
  &-ja,
  &-th,
  &-pl,
  &-hi,
  &-ar,
  &-bn,
  &-ko,
  &-vi,
  &-sw{
    @apply text-[32px] xxs:text-[36px];
  }
  &-tr {
    @apply text-[32px] xxs:text-[32px];
  }
  &-zh {
    @apply leading-[1.2];
  }
  &-ja {
    @apply leading-[1.2];
  }
  &-pt,
  &-fr,
  &-es {
    @apply text-[24px] xxs:text-[30px] 414:text-[32px] lg:text-[28px] xl:text-[32px];
  }
}

.action {
  @apply w-full;
}
</style>
